import SeoHead from '../component/SeoHead';
import metaData from '../data/Meta.json';
import { jsonLdByPath } from '../data/SchemaTag.js';

export async function getServerSideProps(context) {
  const path = context.resolvedUrl.toLowerCase();

  const matchedMeta = metaData.find(item => item.url?.toLowerCase().endsWith(path)) || {};

  const pageJson = jsonLdByPath.find(item => item.url?.toLowerCase().endsWith(path));

  const title = matchedMeta?.title || 'Millance';
  const description = matchedMeta?.description || 'Trade smarter with Millance.';
  const url = matchedMeta?.url || `https://millance.com${path}`;
  const jsonLd = pageJson || null;

  return {
    props: { meta: { title, description, url }, jsonLd, }
  };
}

const Whychoose = ({ meta, jsonLd }) => {

  return (
    <div>
      <SeoHead title={meta.title} description={meta.description} jsonLd={jsonLd} url={meta.url} />
      <div className="why choose us">
        <section className="choose us">
          <div className="choosebanner">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-12 col-lg-6 d-flex flex-column justify-content-center">
                  <h1 className=" mb-2">Why Millance LTD? </h1>
                  <p className=" mb-3">Your Trusted Partner in Smart Trading & Success</p>

                </div>
                <div className="col-md-12 col-lg-6 why-banner-img">
                  <img
                    src={"/images/whychoose/whychoosebanners.png"}
                    alt="logo"
                    className="img-fluid mt-4"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="choose mt-5 mb-5">
          <div className="container">
            <div className="row">
              <div className="choose-text text-center">
                <h2>Why Choose Us</h2>
                <p>
                  Millance LTD is a trusted name in the financial markets, offering a superior trading environment that blends cutting-edge technology, deep liquidity, and seamless execution. Whether you&apos;re a beginner or a seasoned trader, we provide the tools, insights, and support needed to maximize your potential and achieve long-term success.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="Benefits">
          <div className="container">
            <div className="Benefits text-center mt-4">
              <div className="fadeInUp" style={{ animationDelay: "2s" }}>
                <h2>Benefits of Trading with Us</h2>
              </div>
            </div>
            <div className="pamm mt-4">
              <div className="container">
                <div className="fadeInUp" style={{ animationDelay: "2s" }}>
                  <div className="row">
                    <div className="col-lg-4 ">
                      <div className="card">
                        <div className="pamm">
                          <div className="pamm-image ">
                            <img
                              src={"/images/whychoose/levarage2.png"}
                              alt="logo"
                              className="img-fluid"
                            />
                          </div>
                          <div className="Fidelis-text mt-3">
                            <h5>Advanced Leverage Options</h5>
                          </div>
                        </div>
                        <p>
                          Millance LTD empowers traders with high-leverage trading opportunities, enabling them to optimize their profit potential. Select the leverage that aligns with your trading strategy and risk appetite, ensuring maximum flexibility and market adaptability.{" "}
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-4 ">
                      <div className="card">

                        <div className="pamm ">
                          <div className="market-image ">
                            <img
                              src={"/images/whychoose/market-analysis2.png"}
                              alt="logo"
                              className="img-fluid"
                            />
                          </div>
                          <div className="market-text mt-3">
                            <h5> Expert Market Analysis</h5>
                          </div>
                        </div>
                        <p>
                          Informed trading begins with accurate insights. Millance LTD provides in-depth market analysis, including expert reviews, technical forecasts, and fundamental assessments. Stay ahead of market trends with real-time data, professional outlooks, and strategic insights.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-4 ">
                      <div className="card">

                        <div className="pamm ">
                          <div className="tradecopy -image ">
                            <img
                              src={"/images/whychoose/Deposit-and-Withdrawal2.png"}
                              alt="logo"
                              className="img-fluid"
                            />
                          </div>
                          <div className="tradecopy -text mt-3">
                            <h5>Secure & Transparent Transactions</h5>
                          </div>
                        </div>
                        <p>
                          At Millance LTD, we offer a seamless, secure, and transparent deposit and withdrawal process. With a diverse range of payment options, we ensure fast and hassle-free transactions, providing traders with confidence and peace of mind when managing their funds.{" "}
                        </p>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="support mt-3">
          <div className="container">
            <div className="row">
              <div className="multilanguage text-center mt-4">
                <h2>Why copy trade with us</h2>
              </div>
              <div className="customer mt-3">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-4 ">
                      <div className="hovercard">
                        <div className="fidlies d-flex">
                          <div className="Fidelis-image ">
                            <img
                              src={"/images/whychoose/fidlies.png"}
                              alt="logo"
                              className="img-fluid"
                            />
                          </div>
                          <div className="Fidelis-text mt-3 mx-3">
                            <h5>The Ultimate Trading Experience</h5>
                          </div>
                        </div>
                        <p>
                          At Millance LTD, we prioritize trader benefits, offering competitive spreads, lightning-fast execution, and a seamless trading environment with no requotes or dealing desk interference.

                        </p>
                      </div>
                    </div>
                    <div className="col-lg-4 ">
                      <div className="hovercard">
                        <div className="fidlies d-flex">
                          <div className="Fidelis-image ">
                            <img
                              src={"/images/whychoose/lowest-spreds.png"}
                              alt="logo"
                              className="img-fluid"
                            />
                          </div>
                          <div className="Fidelis-text mt-3 mx-3">
                            <h5>Competitive Spreads</h5>
                          </div>
                        </div>
                        <p>
                          Enjoy some of the lowest spreads in the forex industry, with ECN trading offering 0.0 spreads on major currency pairs like EUR/USD and EUR/GBP.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-4 ">
                      <div className="hovercard">
                        <div className="fidlies d-flex">
                          <div className="Fidelis-image ">
                            <img
                              src={"/images/whychoose/lighting.png"}
                              alt="logo"
                              className="img-fluid"
                            />
                          </div>
                          <div className="Fidelis-text mt-1 mx-3">
                            <h5>Ultra-Fast Copy Trade Execution</h5>
                          </div>
                        </div>
                        <p>
                          Our cutting-edge technology ensures lightning-fast copy trade execution, giving you an edge in fast-moving markets.
                        </p>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-lg-4 ">
                        <div className="hovercard">
                          <div className="fidlies d-flex">
                            <div className="Fidelis-image ">
                              <img
                                src={"/images/whychoose/supprior.png"}
                                alt="logo"
                                className="img-fluid"
                              />
                            </div>
                            <div className="Fidelis-text mt-1 mx-3">
                              <h5>Innovative Trading Technology</h5>
                            </div>
                          </div>
                          <p>
                            Millance LTD delivers secure, advanced, and reliable trading technology, providing traders with the tools they need for success.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-4 ">
                        <div className="hovercard">
                          <div className="fidlies d-flex">
                            <div className="Fidelis-image ">
                              <img
                                src={"/images/whychoose/signal.png"}
                                alt="logo"
                                className="img-fluid"
                              />
                            </div>
                            <div className="Fidelis-text mt-1 mx-3">
                              <h5>Real-Time Market Signals</h5>
                            </div>
                          </div>
                          <p>
                            Stay ahead of the market with free real-time trading signals, helping you identify profitable opportunities and make informed decisions.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-4 ">
                        <div className="hovercard">
                          <div className="fidlies d-flex">
                            <div className="Fidelis-image ">
                              <img
                                src={"/images/whychoose/un-parrelal2.png"}
                                alt="logo"
                                className="img-fluid"
                              />
                            </div>
                            <div className="Fidelis-text mt-1 mx-3">
                              <h5>Dedicated Customer Support</h5>
                            </div>
                          </div>
                          <p>
                            Our expert support team is available 24/5 to assist with all your trading needs, ensuring a smooth and hassle-free experience.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="advantage mt-4">
          <div className="why-choose-first">
            <h2>Millance LTD Advantage</h2>
            <p>
              We are proud of our reputation for reliability,
              dependability, customer service, and customer satisfaction. We
              constantly benchmark ourselves against the competition to ensure
              you get the  value for your business.
            </p>
          </div>

        </div>

      </div>
    </div>

  );
};

export default Whychoose;
